import React from 'react';
import { ArrowRight, Users } from 'lucide-react';

const Hero = () => {
  const handleShopClick = () => {
    window.open('https://shop.brownishh.com', '_blank');
  };

  const handleJoinMovement = () => {
    // Scroll to email signup section
    document.querySelector('#mailing-list')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-warmBrown to-deepBrown overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://customer-assets.emergentagent.com/job_melanin-standard/artifacts/l8n4d6eo_IMG_0504.jpeg"
          alt="#Brownishh streetwear"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-richBrown/80 to-deepBrown/60"></div>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-32 h-32 border border-goldAccent rounded-full"></div>
        <div className="absolute bottom-1/3 right-1/4 w-24 h-24 border border-goldAccent rounded-full"></div>
        <div className="absolute top-1/2 right-1/3 w-16 h-16 bg-goldAccent rounded-full"></div>
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Main Headline */}
        <div className="mb-8">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-black text-warmCream leading-tight tracking-tight mb-6">
            Brown isn't a trend.
            <br />
            <span className="text-goldAccent">It's the blueprint.</span>
          </h1>
          
          <p className="text-xl sm:text-2xl text-warmCream/90 font-medium max-w-3xl mx-auto leading-relaxed">
            Streetwear that speaks your truth. 
            <br />
            Beauty that honors your shade.
          </p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button 
            onClick={handleShopClick}
            className="group bg-goldAccent hover:bg-goldAccent/90 text-richBrown font-bold py-4 px-8 rounded-none transition-all duration-300 transform hover:scale-105 hover:shadow-xl flex items-center gap-2 text-lg tracking-wide min-w-[200px]"
          >
            SHOP THE DROP
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300" />
          </button>
          
          <button 
            onClick={handleJoinMovement}
            className="group border-2 border-warmCream text-warmCream hover:bg-warmCream hover:text-richBrown font-bold py-4 px-8 rounded-none transition-all duration-300 flex items-center gap-2 text-lg tracking-wide min-w-[200px]"
          >
            <Users className="w-5 h-5" />
            JOIN THE MOVEMENT
          </button>
        </div>

        {/* Brand Statement */}
        <div className="text-warmCream/80 text-sm font-medium tracking-widest uppercase">
          We're not waiting for permission. We are the standard.
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="w-6 h-10 border-2 border-warmCream/50 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-goldAccent rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;